import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: '',
    loadChildren: () => import('./features/system/system.routes').then((m) => m.routes),
  },
  {
    path: 'analytics/dashboard',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'analytics',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'usuarios',
        redirectTo: 'admin/usuarios',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/analytics/analytics.routes').then((m) => m.routes),
      },
      {
        path: 'perfil',
        loadChildren: () => import('./features/perfil/perfil.routes').then((m) => m.routes),
      },
      {
        path: 'farmas',
        redirectTo: 'farmas/reports/active-ingredient-sales',
        pathMatch: 'full',
      },
      {
        path: 'farmas/reports',
        loadChildren: () =>
          import('./features/farmas/reports/reports.routes').then((m) => m.routes),
      },
      {
        path: 'farmas/pedidos-automaticos',
        loadChildren: () =>
          import('./features/farmas/pedidos-automaticos/pedidos-automaticos.routes').then((m) => m.routes),
      },
      {
        // Antes que 'comercial': es una página de otro feature que cuelga del mismo módulo (sección IA Training).
        path: 'comercial/ia-training/images',
        loadChildren: () => import('./features/ia-training/ia-training.routes').then((m) => m.routes),
      },
      {
        // Antes que 'comercial': sección SST del mismo módulo, en su propio feature.
        path: 'comercial/sst',
        loadChildren: () => import('./features/sst/sst.routes').then((m) => m.routes),
      },
      {
        path: 'comercial',
        loadChildren: () => import('./features/ofertas/ofertas.routes').then((m) => m.routes),
      },
      {
        path: 'centro-aprobaciones',
        loadChildren: () => import('./features/ofertas/ofertas.routes').then((m) => m.centroAprobacionesRoutes),
      },
      {
        path: 'mercadeo/visitas',
        redirectTo: 'mercadeo/auditoria-retail/visitas',
        pathMatch: 'full',
      },
      {
        path: 'mercadeo/reporte',
        redirectTo: 'mercadeo/auditoria-retail/reporte',
        pathMatch: 'full',
      },
      {
        path: 'mercadeo/kpi',
        redirectTo: 'mercadeo/auditoria-retail/kpi',
        pathMatch: 'full',
      },
      {
        path: 'mercadeo/notificaciones',
        redirectTo: 'mercadeo/auditoria-retail/notificaciones',
        pathMatch: 'full',
      },
      {
        path: 'vitaminas',
        redirectTo: 'vitaminas/ecommerce/sincronizador',
        pathMatch: 'full',
      },
      {
        path: 'mercadeo/auditoria-retail',
        loadChildren: () =>
          import('./features/mercadeo/mercadeo.routes').then((m) => m.routes),
      },
      {
        path: 'vitaminas/ecommerce',
        loadChildren: () =>
          import('./features/vitamins/ecommerce/ecommerce.routes').then((m) => m.routes),
      },
      {
        path: 'vitaminas/franquicia',
        loadChildren: () =>
          import('./features/vitamins/franchise/franchise.routes').then((m) => m.routes),
      },
      {
        path: 'salesforce',
        redirectTo: 'salesforce/sincronizacion/productos',
        pathMatch: 'full',
      },
      {
        path: 'salesforce/sincronizacion',
        loadChildren: () =>
          import('./features/salesforce/salesforce.routes').then((m) => m.routes),
      },
      {
        path: 'admin/usuarios',
        loadChildren: () => import('./features/usuarios/usuarios.routes').then((m) => m.routes),
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then((m) => m.routes),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      }
    ],
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];
